// extracted by mini-css-extract-plugin
module.exports = {"overlayConfirmation":"ConfirmationModal_overlayConfirmation__2F_E9"};